module.exports = __webpack_public_path__ + "img/0.ad73d83f.png";